import { Button, Modal, Form, Input, Space, Typography, Switch, Divider, Row, Col } from "antd";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect } from "react";

export const SettingsModal = ({ isOpen, handleOk, handleCancel, clientData, sessionSettings }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({
        ignore_trigger_response: sessionSettings?.ignore_trigger_response || false,
        force_trigger_call: sessionSettings?.force_trigger_call || false,
      });

      if (clientData && Object.keys(clientData).length > 0) {
        const formattedData = Object.entries(clientData).map(([key, value]) => ({ key, value }));
        form.setFieldsValue({ variables: formattedData });
      } else {
        form.setFieldsValue({ variables: [{ key: '', value: '' }] });
      }

    } else if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, clientData, sessionSettings, form]);

  const handleSave = () => {
    form.validateFields()
      .then(values => {
        const finalClientData = (values.variables || []).reduce((acc, { key, value }) => {
          if (key) {
            acc[key] = value;
          }
          return acc;
        }, {});

        const finalSessionSettings = {
          ignore_trigger_response: values.ignore_trigger_response,
          force_trigger_call: values.force_trigger_call,
        };

        handleOk({
          clientData: finalClientData,
          sessionSettings: finalSessionSettings,
        });
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      title="Configurações Opcionais"
      open={isOpen}
      onOk={handleSave}
      onCancel={handleCancel}
      width={600}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={handleSave}>
          Salvar
        </Button>,
      ]}
    >
      <Form
        form={form}
        name="settingsForm"
        autoComplete="off"
        layout="vertical"
      >
        <Typography.Title level={5}>Configurações da Sessão</Typography.Title>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="ignore_trigger_response"
              label="Ignorar resposta do Gatilho"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="force_trigger_call"
              label="Forçar chamada do Gatilho"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Divider style={{ marginTop: 0 }} />

        <Typography.Title level={5}>Variáveis Client Data</Typography.Title>
        <Form.List name="variables">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item {...restField} name={[name, 'key']} rules={[{ required: true, message: 'Chave é obrigatória' }]} style={{ flex: 1 }}>
                    <Input placeholder="Chave" />
                  </Form.Item>
                  <Form.Item {...restField} name={[name, 'value']} rules={[{ required: true, message: 'Valor é obrigatório' }]} style={{ flex: 1 }}>
                    <Input placeholder="Valor" />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  Adicionar Variável
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};
